import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { saveArticle, updateArticle } from './actions';
import Editor from '../../components/common/Editor';
import TextField from '../../components/common/TextField';
import CheckboxField from '../../components/common/CheckboxField';
import SelectField from '../../components/common/SelectField';
import DropNCropField from '../../components/common/DropNCropField';
import { ARTICLE_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class ArticleForm extends Component {
  onSubmit = formProps => {
    const { lang } = formProps;
    const { config } = this.props;

    const articleRequestData = {
      title: formProps.title,
      subtitle: formProps.subtitle,
      content: formProps.content,
      description: formProps.description,
      header: formProps.header,
      headerImageLarge: formProps.headerImageLarge.result,
      showOnHomepage: formProps.showOnHomepage.toString(),
      slug: formProps.slug
    };

    if (config && config.id) {
      // add new mutation for existing article
      this.props.updateArticle(articleRequestData, config.id, lang, () => {
        this.props.history.push('/clanky');
      });
    } else {
      // create brand new article
      this.props.saveArticle(articleRequestData, lang, () => {
        this.props.history.push('/clanky');
      });
    }
  };

  render() {
    const { config, handleSubmit } = this.props;

    return (
      <div className="new-article">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            key="lang"
            component={SelectField}
            label="Jazyk"
            name="lang"
            disabled={config ? config.disableSelect : false}
            validate={required}
          >
            <option value="" key="empty">
              Vyberte jazyk
            </option>
            <option value="cs" key="cs">
              CZ
            </option>
            <option value="en" key="en">
              EN
            </option>
          </Field>
          <Field
            component={TextField}
            type="text"
            label="Hlavní nadpis"
            name="header"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Podnadpis"
            name="subtitle"
            validate={required}
          />
          <Field
            component={DropNCropField}
            label="Hlavní obrázek"
            name="headerImageLarge"
            validate={required}
            minCropBoxWidth={588}
            aspectRatio={16 / 9}
          />
          <div className="editor">
            {/*<Editor placeholder={'Write something...'} />*/}
            <Field
              name="content"
              component={Editor}
              label="Obsah"
              validate={required}
            />
          </div>
          <Field
            component={TextField}
            type="text"
            label="Title"
            name="title"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Url"
            name="slug"
            placeholder="novy-clanek"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Meta description"
            name="description"
            validate={required}
          />
          <Field
            component={CheckboxField}
            label="Zobrazit na homepage"
            name="showOnHomepage"
            checked
          />
          <div className="form-buttons">
            <Button color="primary">Uložit</Button>
            <Button tag={Link} to="/clanky" color="danger">
              Zpět na články
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveArticle,
  updateArticle
};

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  ),
  reduxForm({ form: ARTICLE_FORM_NAME })
)(ArticleForm);



// WEBPACK FOOTER //
// ./src/modules/ArticleForm/index.js